import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';

export function CallsPerHourBarChart({ data, title, additionalData }) {
  const options = {
    responsive: true,
    legend: {
      position: 'top'
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const datasetLabel =
            data.datasets[tooltipItem.datasetIndex].label || '';
          return `${datasetLabel}: ${tooltipItem.yLabel}`;
        },

        footer: (tooltipItems, data) => {
          if (!additionalData || !additionalData[tooltipItems[0].index]) {
            return '';
          }

          const { total, tme, serviceLevel } =
            additionalData[tooltipItems[0].index];

          return [
            `Total: ${total}`,
            `TME: ${tme}`,
            `Nível de Serviço: ${serviceLevel}`
          ];
        }
      }
    },
    scales: {
      xAxes: [
        {
          stacked: true
        }
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };

  return (
    <Row>
      <Col xl="12">
        <Card>
          <CardHeader>
            <h5 className="h3 mb-0">{title}</h5>
          </CardHeader>
          <Row>
            <Col>
              {/*  Rótulo Chamadas Atendidas */}
              <div
                style={{
                  display: 'flex',
                  gap: '20px',
                  marginBottom: '15px',
                  marginTop: '15px',
                  marginLeft: '15px'
                }}
              >
                <div
                  style={{
                    backgroundColor: '#00A07C',
                    color: 'white',
                    fontWeight: '600',
                    padding: '8px 12px',
                    borderRadius: '4px'
                  }}
                >
                  Atendidas
                </div>
                {/*  Rótulo Chamadas Abandonadas */}
                <div
                  style={{
                    backgroundColor: '#d9534f',
                    color: 'white',
                    fontWeight: '600',
                    padding: '8px 12px',
                    borderRadius: '4px'
                  }}
                >
                  Abandonadas
                </div>
              </div>
            </Col>
          </Row>
          <CardBody>
            <div className="chart">
              <Bar data={data} options={options} />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
